import { SetStateAction, useContext, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getUserInfo } from "../../api/userApi";
import { UserContext } from "../../contexts/UserContext";
import Loader from "../Loader/Loader";

export default function ProtectedRoutes() {
  const userContext = useContext(UserContext);
  useEffect(() => {
    if (!userContext.isLoaded) {
      getUserInfo(
        (responseData: SetStateAction<any>) => {
          userContext.setUser({
            name: responseData.name,
            authenticated: responseData.authenticated,
          });
          userContext.setLoaded(true);
        },
        () => {}
      );
    }
  });

  if (!userContext.isLoaded) {
    return <Loader className="mt-5" />;
  }

  if (userContext.user?.authenticated) {
    return <Outlet />;
  }

  return <Navigate to="/login" />;
}
